import homeReducer from './reducers/homeReducer'
import authReducer from './reducers/authReducer'
import cardReducer from './reducers/cardReducer'
import orderReducer from './reducers/orderReducer'
import dashboardReducer from './reducers/dashboardReducer'
import chatReducer from './reducers/chatReducer.js'
import digitalProductReducer from './reducers/digitalProductReducer.js'
import dopingReducer from './reducers/dopingReducer.js'
import ticketReducer from './reducers/ticketReducer.js'
import  balanceReducer  from './reducers/balanceReducer.js'
import  bannerReducer  from './reducers/bannerreducer.js'
import blogReducer from './reducers/blogReducer.js'
import notificationReducer from './reducers/notificationReducer.js'
 import followReducer from './reducers/followReducer'
import cashbackReducer from './reducers/cashbackReducer.js'
import platformReviewReducer from './reducers/platformReviewReducer.js'
import giveawayReducer from './reducers/giveawayReducer.js'
import campaignReducer from './reducers/campaignReducer.js'
import supportReducer from './reducers/supportReducer.js'

const rootReducers = {
    home: homeReducer,
    auth: authReducer,
    card: cardReducer,
    order : orderReducer,
    dashboard : dashboardReducer,
    chat : chatReducer,
    digitalProduct : digitalProductReducer,
    doping : dopingReducer,
    ticket : ticketReducer,
    balance : balanceReducer,
    banner : bannerReducer,
    blog : blogReducer,
    notification: notificationReducer,
    follow: followReducer,
    cashback: cashbackReducer,
    platformReview: platformReviewReducer,
    giveaway: giveawayReducer,
    campaign: campaignReducer,
    support: supportReducer
}
export default rootReducers